import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {AddToCalendarButton} from "add-to-calendar-button-react";
import {playerInformationBullets, registrationLink} from "../../constants";
import { useGetAnnualDisplay } from "../../hooks/useGetAnnualDisplay";
import './player-information.css';

export const PlayerInformation = props => {
    const annualDisplay = useGetAnnualDisplay();
    return (
        <div className="col-md-6">
            {playerInformationBullets.map(({text, icon}, idx) => (
                <h5 key={`player-information-${idx}`}>
                    <FontAwesomeIcon icon={icon}/>
                    <span className="mx-4">{text}</span>
                </h5>
            ))}
            <p>* Price includes cart, complimentary alcoholic beverages, snacks, and dinner.</p>
            <div className="text-center">
                <a className="btn btn-outline-light btn-lg m-2" href={registrationLink} target='_blank' rel="noreferrer">
                    Register Player
                </a>
            </div>
            <h4 className="my-4">Schedule:</h4>
            <ul>
                <li>10:30am Registration</li>
                <li>12:00pm Shotgun Start</li>
                <li>5:00pm Dinner</li>
                <li>6:00pm Raffle</li>
            </ul>
            <div className="calendar-button-wrapper">
                <AddToCalendarButton
                    name={`Bella's Mission ${annualDisplay} Annual Golf Tournament`}
                    description={`Thank you for saving the date to raise awareneess for Vascular Ehlers Danlnos syndrome(VEDs) for the ${annualDisplay} Annual Golf Tournament`}
                    startDate="2026-10-09"
                    startTime="10:30"
                    endTime="18:00"
                    timeZone="America/Denver"
                    location="1858 Cottonwoods Dr, El Paso, TX 79925"
                    options="'Apple','Google', 'iCal','Outlook.com','Yahoo'"
                    iCalFileName={`Bella's Mission ${annualDisplay} Annual Golf Tournament iCal File`}
                />
            </div>
        </div>
    );
};
